import { render, staticRenderFns } from "./PreventLink.vue?vue&type=template&id=4b36e84d&scoped=true&"
import script from "./PreventLink.vue?vue&type=script&lang=js&"
export * from "./PreventLink.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PreventLink.vue?vue&type=style&index=0&id=4b36e84d&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4b36e84d",
  null
  ,true
)

export default component.exports